import React, { useEffect, useRef, useState } from "react";
import api from "./api";
import { BackButton, Button } from "./ui";
import { containsExternalContact } from "./store";

export default function ActivityChat({ activityId, title, isAdmin = false, onBack }) {
  const [messages, setMessages] = useState(null);
  const [text, setText] = useState("");
  const [warn, setWarn] = useState("");
  const [sending, setSending] = useState(false);
  const endRef = useRef(null);

  const load = () => {
    const p = isAdmin ? api.admin.activityChat(activityId) : api.activities.chat(activityId);
    p.then((d) => {
      setMessages(d.messages || []);
      if (d.chatId) api.chats.read(d.chatId).catch(() => {});
    }).catch(() => setMessages([]));
  };
  useEffect(() => {
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityId, isAdmin]);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const send = async () => {
    const t = text.trim();
    if (!t) return;
    if (containsExternalContact(t)) {
      setWarn("Por seguridad, no compartas teléfonos, correos, redes ni contactos externos.");
      return;
    }
    setWarn("");
    setSending(true);
    try {
      if (isAdmin) await api.admin.sendActivityChat(activityId, t);
      else await api.activities.sendChat(activityId, t);
      setText("");
      load();
    } catch (e) {
      setWarn(e.message);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="flex h-full flex-col" data-testid="activity-chat">
      <BackButton onClick={onBack} label="Volver" testId="activity-chat-back" />
      <div className="mt-3">
        <h2 className="text-lg font-bold text-[#0B2D4D]">Chat de la actividad 🐾</h2>
        <p className="text-sm text-slate-500">{title}</p>
      </div>

      <div className="mt-3 flex-1 space-y-2 overflow-y-auto rounded-2xl bg-slate-50 p-3" data-testid="activity-chat-messages">
        {messages === null ? (
          <p className="text-center text-sm text-slate-400">Cargando…</p>
        ) : messages.length === 0 ? (
          <p className="py-8 text-center text-sm text-slate-400">Aún no hay mensajes. ¡Saluda a los participantes! 🐾</p>
        ) : (
          messages.map((m) => (
            <div key={m.id} className={`flex ${m.mine ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[80%] rounded-2xl px-3 py-2 text-sm ${m.mine ? "bg-[#FF5C5C] text-white" : "bg-white text-[#0B2D4D] border border-slate-200"}`}>
                {!m.mine && <p className="mb-0.5 text-[11px] font-bold opacity-70">{m.from}</p>}
                <p className="break-words">{m.text}</p>
                <p className={`mt-0.5 text-[10px] ${m.mine ? "text-white/70" : "text-slate-400"}`}>{m.time}</p>
              </div>
            </div>
          ))
        )}
        <div ref={endRef} />
      </div>

      {warn && (
        <p className="mt-2 rounded-xl bg-rose-50 px-3 py-2 text-xs font-semibold text-rose-700" data-testid="activity-chat-warn">
          {warn}
        </p>
      )}

      <div className="mt-2 flex gap-2 pb-2">
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && send()}
          placeholder="Escribe un mensaje…"
          data-testid="activity-chat-input"
          className="flex-1 rounded-full border border-slate-200 bg-white px-4 py-3 text-sm outline-none focus:border-[#67D5B5]"
        />
        <Button onClick={send} disabled={sending} data-testid="activity-chat-send">
          {sending ? "…" : "Enviar"}
        </Button>
      </div>
      <p className="pb-2 text-center text-[11px] text-slate-400">
        Mensajes protegidos · Se bloquean teléfonos, correos y contactos externos.
      </p>
    </div>
  );
}
